import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import map from 'lodash/map';
import { NavActions } from '../../actions';
import { pureRender } from 'epic-alt-utils';
import { getDataAttribute, getWindowLocationOrigin } from '../../utils/compatibilityUtils';
import { LocaleIcon } from '../';
import { getCurrentLocale } from '../../utils/localeUtils';
import './locale.sass';
import './locale-mobile.sass';

@pureRender
export default class Locale extends React.Component {
    constructor(props) {
        super(props);
        this.warned = false;
    }

    @autobind
    onClick(e) {
        const index = getDataAttribute(e.currentTarget, 'index');
        if (!index) return;
        const locale = this.props.localeOptions[index];
        if (locale && locale.onClick && typeof locale.onClick === 'function') {
            locale.onClick(e);
        }
    }

    getHref(locale) {
        let url = getWindowLocationOrigin() + window.location.pathname + window.location.search;
        if (url.indexOf('lang=') > -1) {
            url = url.replace(/lang=[\w_-]*/, `lang=${locale.lang}`);
        } else {
            if (url.indexOf('?') > -1) {
                url += `&lang=${locale.lang}`;
            } else {
                url += `?lang=${locale.lang}`;
            }
        }

        return url + window.location.hash;
    }

    @autobind
    close() {
        NavActions.mobileLocaleActive(false);
        NavActions.mobileNavActiveLinks(true);
    }

    render() {
        if (!this.props.localeOptions) {
            return <div/>;
        }

        const { currentLocale, locales } = getCurrentLocale(this.props.localeOptions, this.props.locale, this.context.messages.locale);
        const classes = `${this.context.isMobile ? 'rightnav-bg-color' : 'bg-color dropdown'} ${this.props.isActive ?
            'active' : ''} ${locales.length <= 0 ? 'hidden' : ''}`;

        const ulClasses = `locale-list bg-color ${this.context.isMobile ? 'mobile-list' : ''} ${this.props.hideCallToAction ?
            'ul-right' : 'ul-left'}`;

        return (
            <div
                id="locale"
                className={classes}>

                {!this.context.isMobile ? <LocaleIcon currentLocale={currentLocale} isActive={this.props.isActive}/> : ''}

                <ul className={ulClasses}>
                {this.context.isMobile ?
                    <li
                        id="mobileHeading"
                        className="mobile-heading"
                        onClick={this.close}><a><span>{currentLocale}</span></a></li> : ''}

                {
                    map(locales, (locale, i) => {
                        if (locale.lang && locale.lang !== this.props.locale && locale.name) {
                            const href = this.getHref(locale);
                            return (
                                <li
                                    className={`${this.context.isMobile ? 'mobile-list-item' : ''}`}
                                    key={`lang-${locale.lang}`}>
                                    <a href={href} onClick={this.onClick} data-index={i} className="text-color-hover text-color-nonactive">
                                        <span>{locale.name}</span>
                                    </a>
                                </li>
                            );
                        } else if (!this.warned && (!locale.name || !locale.lang)) {
                            if (process.env.NODE_ENV !== 'production') {
                                console.warn('locale object had an invalid [name] or [lang]! Ensure that the localeOptions are correct.');
                            }
                            this.warned = true;
                        }
                        return undefined;
                    })
                }
                </ul>
            </div>
        );
    }
}

Locale.propTypes = {
    localeOptions: React.PropTypes.array,
    isActive: React.PropTypes.bool,
    locale: React.PropTypes.string,
    hideCallToAction: React.PropTypes.bool
};

Locale.contextTypes = {
    isMobile: React.PropTypes.bool,
    messages: React.PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/locale/Locale.js
 **/